import React from 'react';
import classes from './Book.module.css';
import Button from "../../components/button/Button";

const Book = () => {
    return (
        <div className={classes.Container}>
            <div className={classes.ContainerInner}>
                <div className={classes.Paragraph}>
                    First time getting lashes or just need a refresher? Here's your pre-lash appointment rundown so you can arrive prepared!
                </div>
                <div className={classes.Step}>
                    Step 1: Book your appointment!
                </div>
                <div className={classes.Step}>
                    Step 2: (New clients only) Pay your $20 deposit. Accepted forms: Cash, Apple Pay, Zelle, Venmo, PayPal.
                </div>
                <div className={classes.Step}>
                    Step 3: (New clients only) Fill out and sign your lash consent form during your appointment.
                </div>
                <div className={classes.Note}>
                    <div className={classes.Paragraph}>
                        BEFORE YOUR APPOINTMENT:
                        New clients please arrive at least 10 minutes prior to your appointment start time, to allow adequate time to find the studio and receive an initial consultation.
                    </div>
                    <div className={classes.Paragraph}>
                        DO NOT wear eye makeup to your appointment, including mascara, eyeliner and eyeshadow. Avoid using an oil based makeup remover as well as applying oil based moisturizer or sunscreens around the eye. These oils can prevent the glue from bonding properly with your lash and reduce lash retention. A lash cleansing station is available for you but may take time out of your service. So come prepared!
                    </div>
                    <div className={classes.Paragraph}>
                        Please use the restroom before your service. Remember to silence your phone and prepare any music playlist or podcast prior to your appointment start time.
                    </div>
                    <div className={classes.Paragraph}>
                        Your eyes must remain closed for the entirety of your lash service. Opening the eyes can cause irritation from the glue, will disrupt your service and will slow down the process.
                    </div>
                    <div className={classes.Paragraph}>
                        Get ready to lay back, relax and take a nap!
                    </div>
                </div>
                <div className={classes.ButtonWrapper}>
                    <Button onClick={() => window.open('https://pristine-lash.square.site/')}>
                        Book your appointment
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Book;

